module.exports = __webpack_public_path__ + "img/legacy_3.078b26ab.jpg";